import Component from 'vue-class-component'
import ComponentVue from './Component'
import { TextData } from '../../store/editor/components/state'
import { Actions } from '../../store/editor/components/helpers'
import InteractableComponent from './InteractableComponent'
import TextEditor from './TextEditor.vue'

@Component({
  components: {
    'text-editor': TextEditor
  }
})
export default class TextVue extends ComponentVue<TextData> {
  private interactable: InteractableComponent

  get text(): string {
    return this.componentData.text
  }

  set text(text: string) {
    if (this.componentData.text === text) {
      // テキストボックスが編集されないままフォーカスが外れたとき、離脱確認を表示しない
      return
    }
    this.save(Object.assign({}, this.componentData, {
      text
    }))
  }

  mounted(): void {
    this.enableFocus()
    this.interactable = new InteractableComponent(this.$el, this.$store)
    this.interactable.draggable({
      handle: '.text-content__handle',
      extraTransform: 'scale(.7)'
    })
    this.interactable.droppable()
      .onDropTo((event) => {
        Actions.move(this.$store, {
          component: event.dropping,
          destination: this.componentData,
          direction: event.direction
        })
      })
  }

  destroyed(): void {
    this.interactable.destroy()
  }
}
